import { createApp } from 'vue'

import 'amfe-flexible'
import pinia from '@/stores/index'
import App from '@/App.vue'
import router from '@/router'
import i18n from '@/language'
import { tgLogin } from '@/api/login'
import { useBaseStore } from '@/stores'
import { getUrlQuery, changeImgHost, getHashParams, getUrlParams } from '@/utils'
import { directive } from '@/directive'
import { Lazyload } from 'vant'
import { H5Login } from '@/utils/H5Login'
import aes from '@/utils/aes'
import webApp from '@twa-dev/sdk'
import { Log } from '@/api/log'
import '@/theme/index.scss'
import { getDefault } from '@/api/servo'
import { decode, encode } from 'js-base64'
import { IconfontPlugin } from '@/plugins'

// import { registerSW } from 'virtual:pwa-register'
// import { Workbox } from 'workbox-window'
// import { showConfirmDialog } from 'vant'

// import eruda from 'eruda'
// import { encode } from 'js-base64'

// if (import.meta.env.MODE !== 'production') {
//     eruda.init()
// }

// if ('serviceWorker' in navigator && !['betfugu.com'].includes(location.host)) {
//     const wb = navigator.serviceWorker.register('/_sw.js')
//     // wb.register()
//     // 监听激活事件（可选）
//     // wb.addEventListener('activated', (event) => {
//     //     if (event.isUpdate) {
//     //         console.log('Service Worker 已更新，刷新页面生效')
//     //     }
//     // })
// }

if (import.meta.env.MODE === 'production') {
    console.log = console.warn = console.error = console.trace = console.info = () => {}
}
if ('serviceWorker' in window.navigator) {
    // 根据构建模式确定SW配置
    const isDev = import.meta.env.MODE === 'development'
    const swPath = isDev ? '/testpwa/sw.js' : '/sw.js'
    const swScope = isDev ? '/testpwa/' : '/'

    navigator.serviceWorker
        .register(swPath, { scope: swScope })
        .then(function (registration) {
            console.log(`Service Worker registered: ${swPath} (scope: ${swScope})`)
            registration.update()
        })
        .catch((e) => {
            console.log('Service Worker registration failed:', e)
        })
}

const checkUpdate = async () => {
    if ('connection' in navigator && !navigator.onLine) return
    const url = location.protocol + '//' + location.host + location.pathname + 'version.json?date=' + Date.now()
    try {
        const resp = await fetch(url, {
            cache: 'no-store',
            headers: {
                cache: 'no-store',
                'cache-control': 'no-cache',
            },
        })
        if (resp?.status === 200) {
            const data = await resp.json()
            if (__APP_VERSION__ !== data.version) {
                showConfirmDialog({
                    title: i18n.global.t('sys_update_info'),
                    message: i18n.global.t('new_version_update_info'),
                    confirmButtonText: 'Confirm',
                    cancelButtonText: 'Cancel',
                    zIndex: 9999,
                })
                    .then(() => {
                        location.reload()
                    })
                    .catch(() => {})
            }
        }
    } catch (e) {
        console.log(e)
    }
}

window.addEventListener('visibilitychange', async () => {
    if (document.visibilityState === 'visible') {
        setTimeout(() => {
            checkUpdate()
        }, 2000)
    }
})

const app = createApp(App)

app.use(pinia)
    .use(router)
    .use(i18n)
    .use(Lazyload, {
        lazyComponent: true,
        filter: {
            // 在加载前处理图片 URL
            process(lazy) {
                // 替换旧域名为新域名

                lazy.src = changeImgHost(lazy.src)
                return lazy
            },
        },
        preLoad: 1.1,
    })
    .use(IconfontPlugin, {
        url: [
            // 在线icon地址
            // '//at.alicdn.com/t/c/font_4942362_6hxr1fsnrer.js',
            // 本地icon地址
            import.meta.glob('@/assets/icon/iconfont.js', { eager: true }),
        ],
    })
directive(app)
app.config.errorHandler = (err, instance, info) => {
    Log({
        event: 'app_error',
        content: {
            err,
            message: err?.message,
            stack: err?.stack,
            info,
            url: location.href,
        },
    })
    console.error(err)
}

function expandApp() {
    if (webApp.isExpanded) return
    webApp.expand()
}

const store = useBaseStore()
aes.setPureKey(import.meta.env.VITE_PURE)

store.setGameConfig()
loadUrlParams()
let initData = webApp.initData

if (!store.wallet?.currency) {
    const currency = localStorage.getItem('currency')?.toUpperCase() || getHashParams('currency')
    if (currency) {
        store.setWallet({
            currency: currency,
        })
    } else {
        getDefault()
            .then((res) => {
                if (res.code === 200 && res.data.defCurrency) {
                    store.setWallet({
                        currency: res.data.defCurrency,
                    })
                    localStorage.setItem('def_country', res.data.country)
                } else {
                    store.setWallet({
                        currency: 'INR',
                    })
                }
            })
            .catch(() => {
                store.setWallet({
                    currency: 'INR',
                })
            })
    }
}
if (initData) {
    // store.setToken('')
    initData = getUrlQuery(initData)
    store.setTgData(initData)
    webApp.ready()
    expandApp()
    webApp.disableVerticalSwipes()
    // const enParam = aes.aesEncrypt({
    //     userinfo: {
    //         partner: store.partner,
    //         telcontry: '',
    //         unionid: initData.id + 'tg',
    //         nickname: encode(initData.first_name + initData.last_name),
    //         verificode: '',
    //         accesstoken: '',
    //         deviceid: '',
    //         avatar: initData?.photo_url,
    //     },
    // })
    // if (store.token) {

    // } else {
    //     tgLogin({ enParam }, { trackerName: store.promote_url_id }).then((res) => {
    //         store.setToken(res.token)
    //         checkUpdate()
    //         app.mount('#app')
    //     })
    // }
}

checkUpdate()
app.mount('#app')

// 延迟加载google facebook js
if (window.requestIdleCallback) {
    window.requestIdleCallback(() => {
        H5Login.init()
    })
} else {
    H5Login.init()
}

function loadUrlParams() {
    const params = new URLSearchParams(window.location.search)
    let urlParams = {}
    Array.from(params.entries()).forEach(([key, value]) => {
        urlParams[key] = value
    })
    console.log('urlParams', urlParams)
    const zgparams = JSON.parse(localStorage.getItem('__zg_4779402644807_params')) || {}
    if (zgparams) {
        Object.keys(zgparams).forEach((key) => {
            urlParams[key] = zgparams[key]
        })
    }

    const selfpwaparams = JSON.parse(localStorage.getItem('bet_tracking_params')) || {}
    if (selfpwaparams) {
        Object.keys(selfpwaparams).forEach((key) => {
            urlParams[key] = selfpwaparams[key]
        })
    }

    try {
        const telegramparams = urlParams['tgWebAppStartParam']
        if (telegramparams) {
            //将a-b-c-d格式的参数转换为对象{a:b,c:d}
            const tsr = decode(telegramparams).split('-')
            for (let i = 0; i < tsr.length; i += 2) {
                const key = tsr[i]
                const value = tsr[i + 1] || '' // 如果没有值，设置为空字符串
                urlParams[key] = value
            }
        }
    } catch (error) {
        console.log(error)
    }

    try {
        const startapp = urlParams['startapp']
        if (startapp) {
            //将a-b-c-d格式的参数转换为对象{a:b,c:d}
            const tsr = decode(startapp).split('-')
            for (let i = 0; i < tsr.length; i += 2) {
                const key = tsr[i]
                const value = tsr[i + 1] || '' // 如果没有值，设置为空字符串
                urlParams[key] = value
            }
        }
    } catch (error) {
        console.log(error)
    }

    if (urlParams) {
        store.$patch({
            urlParams,
        })
    }

    let link_id = JSON.parse(localStorage.getItem('__zg_4779402644807_link_id')) || urlParams['link_id']
    if (link_id) {
        store.$patch({
            link_id: link_id,
        })
    }
    let promote_url_id = JSON.parse(localStorage.getItem('__zg_4779402644807_promote_url_id')) || urlParams['promote_url_id']
    if (webApp.initData) {
        promote_url_id = urlParams['promote_url_id']
    }
    if (promote_url_id) {
        store.$patch({
            promote_url_id: promote_url_id,
        })
    }

    const id = getUrlParams('userId') || urlParams['userId'] || localStorage.getItem('userId')
    if (id) {
        localStorage.setItem('userId', id)
        store.$patch({
            shareId: +id,
        })
    }

    const webid = getUrlParams('webId') || localStorage.getItem('webId') || urlParams['webId']
    if (webid) {
        localStorage.setItem('webId', webid)
        store.$patch({
            webid: webid,
        })
    }

    //pixel_click_id
    const okspinid = getUrlParams('pixel_click_id') || localStorage.getItem('pixel_click_id') || urlParams['pixel_click_id']
    if (okspinid) {
        localStorage.setItem('pixel_click_id', okspinid)
        store.$patch({
            okspinid: okspinid,
        })
    }

    //_oks_ext
    const okspinext = getUrlParams('_oks_ext') || localStorage.getItem('_oks_ext') || urlParams['_oks_ext']
    if (okspinext) {
        localStorage.setItem('_oks_ext', okspinext)
        store.$patch({
            okspinext: okspinext,
        })
    }
    const from = getUrlParams('sfrom') || localStorage.getItem('sfrom') || urlParams['sfrom']
    if (from) {
        store.$patch({
            sharefrom: from,
        })
    }

    const partner = getUrlParams('partner') || localStorage.getItem('partner') || urlParams['partner']
    if (partner) {
        store.$patch({
            partner: +partner,
        })
    }

    const ntvfrom = getUrlParams('ntvfrom') || localStorage.getItem('ntvfrom') || urlParams['ntvfrom']
    if (ntvfrom) {
        store.$patch({
            ntvfrom: ntvfrom,
        })
    }

    console.log('urlParams', urlParams)
}

// })
// })
// chekVideoMuteState().then((canPlay) => {
//     const store = useBaseStore()
//     if (!canPlay) {
//         store.isMuted = true
//     }
// })
// document.addEventListener('touchstart', function (e) {
//     // e.stopPropagation()
//     // 处理触摸开始事件
// })
// document.addEventListener('touchmove', function (e) {
//     console.log('touchmove', e)
//     // e.stopPropagation()
//     // 处理触摸移动事件
// })
// document.addEventListener('touchend', function (e) {
//     e.stopPropagation()
//     // 处理触摸结束事件
// })
